// src/redux/job/jobConstant.js

export const JOB_ADD = "JOB_ADD";
export const JOB_UPDATE = "JOB_UPDATE";
export const JOB_DELETE = "JOB_DELETE";
export const JOB_LIST = "JOB_LIST";
export const JOB_GET_BY_ID = "JOB_GET_BY_ID";

export const JOB_LOADING = "JOB_LOADING";
export const JOB_ERROR = "JOB_ERROR";
